export default {
    state: {
        //柱状图宽度
        barWidth: '15',
        data_base: [],//数据库信息
        protocol_data: [],//三方信息
        project_id: JSON.parse(window.sessionStorage.getItem('project_id')),//项目ID
        // project_code: JSON.parse(window.sessionStorage.getItem('project_code')),//项目ID
        project_name: JSON.parse(window.sessionStorage.getItem('project_name')),
        platform_Id: JSON.parse(window.sessionStorage.getItem('platform_Id')),//平台ID
        platform_name:JSON.parse(window.sessionStorage.getItem('platform_name')),
        func_user:[],
        province_list:[],
        city_list:[],
        county_list:[],

    },
    mutations: {

        // 新建项目时,多组数据库信息
        data_base_data(state, data) {
            state.data_base = data
        },
        show_input(state, data){
            state.show_input = data
        },
        // 新建三方
        get_protocol_data(state, data) {
            state.protocol_data = data
        },
        //项目id
        push_project_id(state, data) {
            state.project_id = data
            window.sessionStorage.setItem('project_id', JSON.stringify(data))
        },
        //项目实体编码
        push_project_code(state, data) {
            state.project_code = data
            window.sessionStorage.setItem('project_code', JSON.stringify(data))
        },
        //项目name
        push_project_name(state, data) {
            state.project_name = data
            window.sessionStorage.setItem('project_name', JSON.stringify(data))
        },
        //平台id
        push_platform_id(state, data) {
            state.platform_Id = data
            window.sessionStorage.setItem('platform_Id', JSON.stringify(data))
        },
        //平台名称
        push_platform_name(state, data) {
            state.platform_name = data
            window.sessionStorage.setItem('platform_name', JSON.stringify(data))
        },
        //功能组-用户
        set_func_user(state, data) {
            state.func_user = data

        },
        //功能组-sheng
        set_province_list(state, data) {
            state.province_list = data

        },
        //功能组-市
        set_city_list(state, data) {
            state.city_list = data

        },
        //功能组-区县
        set_county_list(state, data) {
            state.county_list = data

        },
    },
    actions: {},
    getters: {}
}